<div
  *ngIf="step && !isHidden"
  class="options-component"
  style="overflow: hidden"
  [appAutoFocus]="controlAutoFocusEnabled"
  [autoFocusSkipMobile]="controlAutoFocusEnabled"
  [@collapse]="animationState"
  (@collapse.done)="onCollapseDone()"
>
  <ng-content></ng-content>
  <div
    class="text-help option-text agent-select-option-text"
    *ngIf="options.length > 1"
  >
    {{ 'choose_an_option' + (isFormal ? '_is_formal' : '') | translate }}
  </div>
  <div
    style="display: flex"
    [ngStyle]="{
      'flex-direction':
        step.type === stepType.FEEDBACK ||
        step.type === stepType.AI_FEEDBACK ||
        isNpsStyle
          ? 'row'
          : 'column',
      'flex-wrap': isNpsStyle ? 'wrap' : 'nowrap',
      padding: isNpsStyle ? '0px 15px' : '0px',
      'justify-content': isNpsStyle ? 'center' : 'normal'
    }"
    class="all-options-wrapper"
    [attr.role]="options.length > 0 ? 'group' : null"
    [attr.aria-labelledby]="questionLabelledBy || null"
  >
    <span
      *ngIf="primaryOptionsDisabled"
      class="sr-only"
      [attr.id]="primaryOptionsHintId"
      >{{
        processFormOfAddressMessageString('ai_answer_required_hint') | translate
      }}</span
    >
    <ng-container *ngFor="let option of options; let i = index">
      <div
        [@zoomIn]="{
          value: '',
          params: {
            delay: isNpsStyle ? i * 50 : i * 200
          }
        }"
        class="option-button-wrapper"
        [ngStyle]="{
          flex: option.button?.['width']
            ? option.button?.['width']
            : isNpsStyle
              ? ''
              : '1',
          'margin-bottom':
            option.text &&
            option.text[currentLang] &&
            option.text[currentLang].trim() !== ''
              ? '5px'
              : null
        }"
        [ngClass]="[
          isNpsStyle ? 'nps-option ' : '',
          option.button?.['style'] ? option.button?.['style'] : ''
        ]"
      >
        <ng-container
          *ngIf="
            option.text &&
            option.text[currentLang] &&
            option.text[currentLang].trim() !== ''
          "
        >
          <button
            (click)="onClick(option)"
            mat-flat-button
            class="chat-step user-option-button full-width"
            style="display: flex; height: 60px; flex-grow: 1"
            [ngStyle]="{
              'justify-content': alignCenter ? 'center' : 'start'
            }"
            [ngClass]="[
              isNpsStyle
                ? 'agent-nps-option-button'
                : '',
              step.type === stepType.EMPLOYEE_SELECTION
                ? 'employee-selection-button'
                : ''
            ]"
            [disabled]="
              !isOptionButtonEnabled || isPrimaryOptionBlocked(option)
            "
            [disabledInteractive]="isPrimaryOptionBlocked(option)"
            [attr.aria-describedby]="
              isPrimaryOptionBlocked(option) ? primaryOptionsHintId : null
            "
            [attr.aria-label]="
              isNpsStyle
                ? ('nps_rating_aria' | translate) +
                  ' ' +
                  option.text[currentLang]
                : (option.text[currentLang] | translate)
            "
          >
            <div
              class="user-option-button-text"
              style="display: flex; align-items: center"
              [ngStyle]="{ 'margin-left': alignCenter ? '0px' : '20px' }"
            >
              <ng-container *ngIf="option.icon">
                <ng-container
                  *ngIf="
                    option.icon.startsWith('https');
                    else localIconTemplate
                  "
                >
                  <div
                    style="
                      display: flex;
                      justify-content: start;
                      align-items: start;
                      margin-right: 15px;
                    "
                  >
                    <img
                      [src]="option.icon"
                      style="width: auto"
                      class="icon-emoji"
                    />
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #localIconTemplate>
                <mat-icon
                  *ngIf="option.icon != 'logo-share-api'"
                  style="margin-right: 15px"
                  class="icon-emoji"
                  [svgIcon]="option.icon"
                  aria-hidden="true"
                ></mat-icon>
              </ng-template>
              <span *ngIf="option.icon === 'logo-share-api'; else normalText">
                {{ 'share_api_option_text' | translate }}
              </span>
              <ng-template #normalText>
                {{ option.text[currentLang] | translate }}
              </ng-template>
            </div>
          </button>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="step.type === stepType.RATING_NPS">
    <div
      class="text-help option-text nps-score-text"
      style="text-align: center"
    >
      {{ 'nps_scale_meaning' | translate }}
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      (step.type === stepType.RATING || step.type === stepType.RATING_NPS) &&
      step.privacy_policy.is_enabled
    "
  >
    <div
      class="text-help option-text rating-step-policy-text"
      style="text-align: center"
    >
      {{
        step.privacy_policy.text_before_link.message[currentLang] | translate
      }}

      <a
        [href]="step.privacy_policy.link.message[currentLang]"
        target="_blank"
        class="text-help rating-step-policy-text-link"
        >{{ step.privacy_policy.text.message[currentLang] | translate }}</a
      >
    </div>
  </ng-container>
</div>
